<template>
    <div class="row">
        <form class="col s12" @submit.prevent="checkForm">
            <div class="card-panel">
                <div class="row">
                    <div class="input-field col s12">
                        <input type="text" placeholder="Title" class="validate" id="title" v-model="title" required>
                        <label for="title">Task Title</label>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col s12">
                        <input type="text" placeholder="Due Date" class="datepicker" id="date" v-model="due_date" required>
                        <label for="date">Due Date</label>
                    </div>
                </div>
                <div class="row" v-for="(task, index) in tasks" v-if="tasks.length > 0">
                    <div class="input-field col s8">
                        <input type="text" placeholder="Task Description" class="validate" v-model="task.name" required>
                    </div>
                    <div class="col s4">
                        <a class="waves-effect waves-light red btn" v-on:click="deleteTask(index, task)"><i class="material-icons left">delete</i>Delete Task</a>
                    </div>
                </div>
                <div class="row" >
                    <div class="col s6">
                        <a class="waves-effect waves-light btn" v-on:click="addTask"><i class="material-icons left">add</i>Add Task</a>
                    </div>
                    <div class="col s6 right-align">
                        <button class="green btn waves-effect waves-light" type="submit" name="action" v-if="is_edit == 0">Submit
                            <i class="material-icons right">send</i>
                        </button>
                        <button class="orange btn waves-effect waves-light" type="submit" name="action" v-if="is_edit == 1">Edit
                            <i class="material-icons right">edit</i>
                        </button>
                    </div>

                </div>
            </div>
        </form>
    </div>
</template>
<script>
    import axios from 'axios'

    export default {
        name: 'DiaryForm',

        props: {
            actionUrl: String,
            successUrl: String,
            deleteUrl: String,
            diary: String,
            currentDate: String
        },

        data() {
            return {
                title: '',
                due_date: '',
                tasks: [],
                single_diary: '',
                is_edit: 0
            }
        },

        mounted() {
            this.initDatePicker();

            if (this.diary !== undefined)
            {
                this.single_diary = JSON.parse(this.diary);
                this.title = this.single_diary.title;
                this.due_date = Moment(this.single_diary.due_date).format('DD-MM-YYYY');
                this.tasks = this.single_diary.tasks;
                this.is_edit = 1;
            } else {
                this.addTask(); // trigger at least one task
            }


        },

        methods: {
            addTask() {
                var me = this;
                this.tasks.push({name: ''});
            },
            deleteTask(index, task) {
               var me  = this;
               this.tasks.splice(index, 1);

                axios.post(this.deleteUrl,
                    {
                        'id' : task.id

                    }).then(response => {

                    if(response.data.success) {
                        M.toast({html:  response.data.messages, classes: 'success accent-2'});
                    } else {
                        M.toast({html: 'Error, ' + response.data.messages, classes: 'red accent-2'});
                    }

                }).catch(err => {
                });
            },
            checkForm() {
                axios.post(this.actionUrl,
                    {
                        'title' : this.title,
                        'due_date' : this.due_date,
                        'tasks' : this.tasks

                    }
                ).then(response => {

                    if(response.data.success) {
                        M.toast({html:  response.data.messages, classes: 'success accent-2'});
                        window.location.href = this.successUrl;
                    } else {
                        M.toast({html: 'Error, ' + response.data.messages, classes: 'red accent-2'});
                    }

                }).catch(err => {
                  let str = '';
                  if (err.response.data.errors.hasOwnProperty('tasks')) {
                    str += "The tasks field is required. <br>(click '+ Add Task' to proceed)"
                    M.toast({html: 'Opps, ' + str, classes: 'orange'});
                  } else {
                    // default error
                    M.toast({html: 'Error, ' + err.response.data.message, classes: 'red accent-2'});
                  }

                });
            },

            initDatePicker() {
                var me = this;
                var today
                document.addEventListener('DOMContentLoaded', function() {
                    var elems = document.querySelectorAll('.datepicker');
                    var instances = M.Datepicker.init(elems, {
                        format: 'dd-mm-yyyy',
                        minDate: new Date(),
                        autoClose: true,
                        onSelect: function(date) {
                            var string_date = date.toDateString();
                            me.due_date = Moment(string_date).format('DD-MM-YYYY');
                        }
                    });
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/diaries/DiaryForm.vue